import { ref } from "vue";
import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type { ArctianAccount, ArctitanSender, Tag } from "@/types/arctitan";

export const useArctitanStore = defineStore("arctitan", () => {
  const tag = ref<Tag>({
    reserved: false,
    consumed: false,
  });
  const arctianAccount = ref<ArctianAccount>({
    name: "",
    email: "",
    country: "",
    uuid: "",
  });

  const hasTagMsp = async ({
    formData,
    uuid,
  }: ArctitanSender): Promise<void> => {
    const res = await $http.post(`${getApiClientUrl()}/v1/arctitan/msps/tag`, {
      mspName: formData.name,
      country: formData.country,
      mspOrganisationID: uuid,
    });

    tag.value = res.data;
  };

  const hasTagCustomer = async ({
    formData,
    uuid,
  }: ArctitanSender): Promise<void> => {
    const res = await $http.post(
      `${getApiClientUrl()}/v1/arctitan/msps/${uuid}/customers/tag`,
      {
        customerOrganisationID: formData.uuid,
        customerName: formData.name,
      },
    );

    tag.value = res.data;
  };

  const createMspArctian = async ({
    formData,
    uuid,
  }: ArctitanSender): Promise<void> => {
    const res = await $http.post(`${getApiClientUrl()}/v1/arctitan/msps`, {
      mspOrganisationID: uuid,
      mspName: formData.name,
      mspEmailAdmin: formData.email,
      country: formData.country,
    });

    arctianAccount.value = res.data;
  };

  const createCustomerArctian = async ({
    formData,
    uuid,
  }: ArctitanSender): Promise<void> => {
    const res = await $http.post(
      `${getApiClientUrl()}/v1/arctitan/${uuid}/customers`,
      {
        customerOrganisationID: formData.uuid,
        customerEmailAdmin: formData.email,
        customerName: formData.name,
      },
    );

    arctianAccount.value = res.data;
  };

  return {
    tag,
    arctianAccount,
    hasTagMsp,
    hasTagCustomer,
    createMspArctian,
    createCustomerArctian,
  };
});
